module.exports = __webpack_public_path__ + "static/media/refil-fr600.c0a4188f.jpg";